import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "cw-popup-message-modal",
    templateUrl: "./popup-message-modal.component.html",
    styleUrls: ["./popup-message-modal.component.scss"],
    standalone: false
})
export class PopupMessageModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PopupMessageModalComponent>
  ) {}

  onBtnClick(index: number) {
    this.dialogRef.close({ action: index });
  }
}
